import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const SliderRoutes: RouteRecordRaw = {
  path: '/slider',
  name: 'SliderModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageSliderRoute',
      component: () => import('./views/ManageSliderView.vue'),
      meta: {
        title: 'اسلایدرها',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.slider,
  },
}

export default (router: Router) => {
  router.addRoute(SliderRoutes)
}
